import axios from 'axios';

const API_BASE_URL = 'https://dfsclientapi.makebettinggreat.com/v1/';
const ENDPOINT_LEAGUE = API_BASE_URL + 'league/';
const ENDPOINT_MATCH = 'https://dfsclientapi.makebettinggreat.com/v2/' + 'match/';
const API_SUCCESS_CODE = "0000"

export const getLeaguesByDate = async date => {
    const url = ENDPOINT_LEAGUE + date
    const result = await axios.get(url)
    const data = result.data
    if(data.status.returnCode === API_SUCCESS_CODE) {
        return data.response
    }else {
        return []
    }
}

// export const getLeaguesByDateCallback = (date, callback) => {
//     const url = ENDPOINT_LEAGUE + date
//     const result = axios.get(url).then(
//         result => {
//             callback(result.data.response)
//         }
//     )
// }

export const getMatchesByDate = async date => {
    const url = ENDPOINT_MATCH + date
    const result = await axios.get(url)
    const data = result.data
    if(data.status.returnCode === API_SUCCESS_CODE) {
        return data.response
    }else {
        return []
    }
}

export const getMatchScore = async bfEventID => {
    const url = 'https://rapidapiscrapper.makebettinggreat.com/v1/match/score/' + bfEventID
    const result = await axios.get(url)
    const data = result.data
    if(data.status.returnCode === API_SUCCESS_CODE) {
        return data.response
    }else {
        return []
    }
}